var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5"},[_c('v-alert',{attrs:{"icon":"mdi-information-outline","outlined":"","type":"success","text":"","dark":""}},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }